// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3CBJu","productName":"Table_productName__37HYZ"};